import { formatToDateInput } from '@maia/utils';

export function mapToAnswer(formData: FormData) {
  return Object.entries(formData).map(([guid, answer]) => {
    return {
      guid,
      answer: formatDateAnswerValue(answer),
    };
  });
}

function isDate(value: unknown): value is Date {
  return value instanceof Date;
}

function formatDateAnswerValue(value: any): string | Date | undefined {
  if (isDate(value)) {
    return formatToDateInput(value);
  }
  return value;
}
